exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-table[data-v-26ed7738]{width:1.25rem}@media (min-width:500px){.card-header[data-v-26ed7738]{flex-direction:row}}", ""]);

// exports
